import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useReactFlow } from "@xyflow/react";

import { addNodeOnClickSetter } from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";
import useGetNodeDataByTypeFn from "../../hooks/useGetNodeDataByTypeFn";

export function useOnPaneClick(
  ref: React.MutableRefObject<HTMLDivElement | null>,
) {
  const { screenToFlowPosition, getIntersectingNodes } = useReactFlow();
  const getNodeDataByType = useGetNodeDataByTypeFn();
  const { emitEventOnAddStep, emitEventOnAddPath } =
    useEmitUserInteractionEvents();
  const addNodeAndSave = useSetAtom(addNodeOnClickSetter);

  const onPaneClick = useCallback(
    (event: React.MouseEvent) => {
      addNodeAndSave({
        event,
        ref,
        emitEventOnAddStep,
        emitEventOnAddPath,
        screenToFlowPosition,
        getIntersectingNodes,
        getNodeDataByType,
      });
    },
    [
      addNodeAndSave,
      emitEventOnAddPath,
      emitEventOnAddStep,
      getIntersectingNodes,
      getNodeDataByType,
      ref,
      screenToFlowPosition,
    ],
  );

  return { onPaneClick };
}
